(function () {
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // scroll-reveal: fade + rise up the big repeating imagery/cards as they enter view
  try {
    if (!prefersReducedMotion && 'IntersectionObserver' in window) {
      var revealSelectors = '.pillar, .pcard, .range-card, .video-card, .swatch-chip, .learn-card, .cross-card, .tile, .brandintro-item, #colourshow .layout > div, .panel .copy';
      var revealEls = document.querySelectorAll(revealSelectors);
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
      revealEls.forEach(function (el, i) {
        el.classList.add('reveal');
        el.style.transitionDelay = (Math.min(i % 4, 3) * 0.08) + 's';
        revealObserver.observe(el);
      });
    }
  } catch (e) {}

  // parallax drift on big full-bleed lifestyle photography
  try {
    if (!prefersReducedMotion) {
      var parallaxImgs = document.querySelectorAll('img[data-parallax]');
      if (parallaxImgs.length) {
        var ticking = false;
        function updateParallax() {
          parallaxImgs.forEach(function (img) {
            var rect = img.parentElement.getBoundingClientRect();
            var vh = window.innerHeight;
            if (rect.bottom < 0 || rect.top > vh) return;
            var progress = (rect.top) / vh;
            var shift = progress * -60;
            img.style.transform = 'translateY(' + shift + 'px)';
          });
          ticking = false;
        }
        window.addEventListener('scroll', function () {
          if (!ticking) {
            requestAnimationFrame(updateParallax);
            ticking = true;
          }
        }, { passive: true });
        updateParallax();
      }
    }
  } catch (e) {}

  // sticky nav border on scroll
  try {
    var nav = document.getElementById('nav');
    if (nav) {
      window.addEventListener('scroll', function () {
        nav.classList.toggle('scrolled', window.scrollY > 8);
      }, { passive: true });
    }
  } catch (e) {}

  // Colourway swatches are real links to sibling PRODUCTS (Magic doesn't use variants for
  // colour — every colourway is its own product). Clicking navigates for real; hovering/
  // focusing previews that product's image, stage tint and price without leaving the page.
  (function () {
    function applyPreview(sw, group) {
      var targetSel = group.getAttribute('data-swatch-target');
      var img = targetSel ? group.querySelector(targetSel) : group.querySelector('img');
      if (img && sw.getAttribute('data-img')) img.src = sw.getAttribute('data-img');

      var stageSel = group.getAttribute('data-swatch-stage');
      var stage = stageSel ? group.querySelector(stageSel) : null;
      if (stage && sw.getAttribute('data-tint')) stage.style.background = sw.getAttribute('data-tint');

      var label = group.querySelector('[data-swatch-label]');
      if (label) label.textContent = (sw.getAttribute('data-name') || '').toUpperCase() + (sw.classList.contains('active') ? ' — selected' : ' — preview');

      var priceSel = group.getAttribute('data-price-target');
      var priceEl = priceSel ? group.querySelector(priceSel) : null;
      if (priceEl && sw.getAttribute('data-price')) priceEl.textContent = sw.getAttribute('data-price');

      var ctaSel = group.getAttribute('data-swatch-cta');
      var cta = ctaSel ? group.querySelector(ctaSel) : null;
      if (cta && sw.tagName === 'A' && sw.getAttribute('href')) cta.setAttribute('href', sw.getAttribute('href'));
    }
    function resetPreview(group) {
      var active = group.querySelector('.swatch.active, .cw-row.active, .swatch-chip.active');
      if (active) applyPreview(active, group);
    }
    document.querySelectorAll('[data-swatch-group]').forEach(function (group) {
      group.querySelectorAll('.swatch, .cw-row, .swatch-chip').forEach(function (sw) {
        sw.addEventListener('mouseenter', function () { applyPreview(sw, group); });
        sw.addEventListener('focus', function () { applyPreview(sw, group); });
      });
      group.addEventListener('mouseleave', function () { resetPreview(group); });
      group.addEventListener('focusout', function (evt) {
        if (!group.contains(evt.relatedTarget)) resetPreview(group);
      });
    });
  })();

  // Live PDP configurator — swatch click AJAX-swaps the whole product (image, price,
  // stock, variant, 2nd-life bundle) in place using Shopify's own /products/x.js data,
  // instead of a full page reload. Falls back to a real navigation if the fetch fails.
  try {
    function money(cents) { return '$' + (cents / 100).toFixed(2); }
    function handleize(s) {
      return String(s).toLowerCase().replace(/[^a-z0-9\s-]/g, '').trim().replace(/[\s-]+/g, '-');
    }
    function withWidth(url, w) {
      if (!url) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    function pickVariant(product) {
      var avail = product.variants.filter(function (v) { return v.available; });
      return avail[0] || product.variants[0];
    }
    function setLoading(group, on) { group.classList.toggle('swatch-loading', !!on); }

    function swapProduct(group, sw, data) {
      var variant = pickVariant(data);

      var stageScroll = document.querySelector('.stage-scroll');
      if (stageScroll && data.images && data.images.length) {
        var galleryImgs = data.images.slice(0, 6);
        stageScroll.innerHTML = galleryImgs.map(function (img, i) {
          var isFirst = i === 0;
          var cls = isFirst ? 'stage-photo stage-photo-hero' : 'stage-photo';
          var idAttr = isFirst ? ' id="heroImg"' : '';
          var altText = (data.title || '').replace(/"/g, '') + (isFirst ? '' : ' — view ' + (i + 1));
          return '<img' + idAttr + ' class="' + cls + '" src="' + withWidth(img, isFirst ? 1200 : 900) + '" alt="' + altText + '">';
        }).join('');
      } else {
        var targetSel = group.getAttribute('data-swatch-target');
        var heroImg = targetSel ? document.querySelector(targetSel) : null;
        if (heroImg && data.featured_image) { heroImg.src = withWidth(data.featured_image, 900); heroImg.alt = data.title; }
      }

      var priceEl = document.querySelector('[data-swatch-price]');
      if (priceEl) {
        var html = '';
        if (data.compare_at_price && data.compare_at_price > data.price) html += '<del>' + money(data.compare_at_price) + '</del>';
        html += money(data.price);
        priceEl.innerHTML = html;
      }

      var label = group.querySelector('[data-swatch-label]');
      if (label) label.textContent = (sw.getAttribute('data-name') || '').toUpperCase() + ' — selected';

      var stockPill = document.querySelector('[data-stock-pill]');
      if (stockPill) {
        stockPill.textContent = data.available ? 'In stock' : 'Sold out';
        stockPill.classList.toggle('in', data.available);
        stockPill.classList.toggle('out', !data.available);
      }

      var form = document.getElementById('pdp-buy-form');
      var variantInput = form ? form.querySelector('[data-variant-id-input]') : null;
      if (variantInput) variantInput.value = variant.id;

      var buyBtn = form ? form.querySelector('[data-buy-btn]') : null;

      function refreshBuyBtn() {
        if (!buyBtn || !form) return;
        buyBtn.disabled = !data.available;
        if (!data.available) { buyBtn.textContent = 'Sold out'; return; }
        var base = parseInt(form.getAttribute('data-price-base-cents'), 10) || 0;
        var total = base;
        form.querySelectorAll('[data-addon-toggle]:checked').forEach(function (t) {
          total += parseInt(t.getAttribute('data-addon-price-cents'), 10) || 0;
        });
        buyBtn.innerHTML = 'Add to cart — <span data-buy-btn-price>' + money(total) + '</span>';
      }

      // 2nd-life bundle: re-derive the colour-matched lid product handle and fetch it for real
      var slot = document.querySelector('[data-bundle-slot]');
      var lidPrefix = group.getAttribute('data-lid-prefix');
      if (form) form.setAttribute('data-price-base-cents', data.price);

      if (slot && lidPrefix) {
        var lidHandle = lidPrefix + '-' + handleize(sw.getAttribute('data-name') || '');
        fetch('/products/' + lidHandle + '.js')
          .then(function (r) { if (!r.ok) throw new Error('no lid'); return r.json(); })
          .then(function (lid) {
            if (!lid.available) throw new Error('lid unavailable');
            var lidVariant = pickVariant(lid);
            slot.innerHTML = '<label class="bundle-add"><input type="checkbox" data-addon-toggle data-addon-variant-id="' + lidVariant.id + '" data-addon-price-cents="' + lid.price + '"><img src="' + withWidth(lid.featured_image, 160) + '" alt="' + (lid.title || '').replace(/"/g, '') + '"><span class="bundle-txt"><b>Give it a 2nd life</b> — add the matching bathroom lid<span class="bundle-price mono">+ ' + money(lid.price) + '</span></span></label>';
            var newToggle = slot.querySelector('[data-addon-toggle]');
            if (newToggle) newToggle.addEventListener('change', refreshBuyBtn);
            refreshBuyBtn();
          })
          .catch(function () { slot.innerHTML = ''; refreshBuyBtn(); });
      } else {
        refreshBuyBtn();
      }

      document.title = (data.title || document.title) + ' – Magic';
      if (window.history && sw.tagName === 'A') window.history.pushState(null, '', sw.getAttribute('href'));
    }

    document.addEventListener('click', function (evt) {
      var sw = evt.target.closest('.swatch, .swatch-chip');
      if (!sw) return;
      var group = sw.closest('[data-swatch-live="1"]');
      if (!group) return;
      evt.preventDefault();
      if (sw.getAttribute('data-oos') === '1' || sw.classList.contains('active')) return;
      var href = sw.getAttribute('href');
      if (!href) return;
      group.querySelectorAll('.swatch, .swatch-chip').forEach(function (s) { s.classList.remove('active'); });
      sw.classList.add('active');
      setLoading(group, true);
      fetch(href + '.js')
        .then(function (r) { if (!r.ok) throw new Error('fetch failed'); return r.json(); })
        .then(function (data) { swapProduct(group, sw, data); })
        .catch(function () { window.location.href = href; })
        .then(function () { setLoading(group, false); });
    });
  } catch (e) {}

  // mechanism / stage step tabs
  document.addEventListener('click', function (evt) {
    var step = evt.target.closest('[data-step]');
    if (!step) return;
    var group = step.closest('[data-step-group]');
    if (!group) return;
    var targetSel = group.getAttribute('data-step-target');
    var img = targetSel ? group.querySelector(targetSel) : null;
    var videoSel = group.getAttribute('data-video-target');
    var video = videoSel ? group.querySelector(videoSel) : null;
    group.querySelectorAll('[data-step]').forEach(function (s) { s.classList.remove('active'); });
    step.classList.add('active');
    var videoUrl = step.getAttribute('data-video');
    if (video && videoUrl) {
      if (video.getAttribute('src') !== videoUrl) video.setAttribute('src', videoUrl);
      video.hidden = false;
      if (img) img.hidden = true;
      video.play().catch(function () {});
    } else {
      if (video) { video.hidden = true; video.pause(); }
      if (img) { img.hidden = false; if (step.getAttribute('data-img')) img.src = step.getAttribute('data-img'); }
    }
    var numEl = group.querySelector('[data-step-num]');
    if (numEl && step.getAttribute('data-num')) numEl.textContent = step.getAttribute('data-num');
  });

  // faq accordions
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('.faq-item > button');
    if (!btn) return;
    var item = btn.closest('.faq-item');
    var faqRoot = item.closest('.faq');
    var wasOpen = item.getAttribute('data-open') === '1';
    faqRoot.querySelectorAll('.faq-item').forEach(function (i) {
      i.setAttribute('data-open', '0');
      i.querySelector('button').setAttribute('aria-expanded', 'false');
    });
    if (!wasOpen) {
      item.setAttribute('data-open', '1');
      btn.setAttribute('aria-expanded', 'true');
    }
  });

  // sticky product buy bar
  try {
    var bar = document.getElementById('stickybar');
    var pdpHero = document.getElementById('pdphero');
    if (bar && pdpHero) {
      window.addEventListener('scroll', function () {
        bar.classList.toggle('show', pdpHero.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }
  } catch (e) {}

  // Ask Magic scripted demo (answers configured via data attributes on each chip)
  try {
    var chat = document.getElementById('askChat');
    if (chat) {
      document.querySelectorAll('.ask-chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var q = chip.textContent.trim();
          var a = chip.getAttribute('data-answer') || "Good question — that's not in the live FAQ yet, I'd flag it for a human to answer.";
          var userMsg = document.createElement('div');
          userMsg.className = 'msg user';
          userMsg.textContent = q;
          chat.appendChild(userMsg);
          chip.disabled = true;
          chip.style.opacity = .4;
          var typing = document.createElement('div');
          typing.className = 'typing';
          typing.innerHTML = '<span></span><span></span><span></span>';
          chat.appendChild(typing);
          chat.scrollTop = chat.scrollHeight;
          setTimeout(function () {
            typing.remove();
            var botMsg = document.createElement('div');
            botMsg.className = 'msg bot';
            botMsg.textContent = a;
            chat.appendChild(botMsg);
            chat.scrollTop = chat.scrollHeight;
          }, 700);
        });
      });
    }
  } catch (e) {}

  // Portrait product reel — click to play/pause real vertical footage
  try {
    document.querySelectorAll('.reel-stage').forEach(function (stage) {
      var video = stage.querySelector('.reel-video');
      var playBtn = stage.querySelector('.reel-play');
      if (!video || !playBtn) return;
      playBtn.addEventListener('click', function () {
        if (video.paused) { video.play(); playBtn.classList.add('is-playing'); }
        else { video.pause(); playBtn.classList.remove('is-playing'); }
      });
      video.addEventListener('click', function () {
        if (!video.paused) { video.pause(); playBtn.classList.remove('is-playing'); }
      });
      video.addEventListener('ended', function () { playBtn.classList.remove('is-playing'); });
    });
  } catch (e) {}

  // PDP thumbnail gallery — click a real angle photo to swap the hero stage image.
  // Delegated so it keeps working after the live configurator regenerates the thumb list.
  try {
    document.addEventListener('click', function (evt) {
      var thumb = evt.target.closest('.pdp-thumb');
      if (!thumb) return;
      var group = thumb.closest('[data-pdp-thumbs]');
      if (!group) return;
      var targetSel = group.getAttribute('data-thumb-target');
      var heroImg = targetSel ? document.querySelector(targetSel) : null;
      if (!heroImg) return;
      heroImg.src = thumb.getAttribute('data-img');
      group.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  } catch (e) {}

  // add-on upsells (e.g. bathroom lid, nappy bag roll) and real Subscribe & Save selling
  // plans: any checked add-on or a chosen subscription frequency updates the visible total
  try {
    function moneyFmt(cents) { return '$' + (cents / 100).toFixed(2); }
    document.querySelectorAll('form[data-price-base-cents]').forEach(function (form) {
      var priceEl = form.querySelector('[data-buy-btn-price]');
      if (!priceEl) return;

      function recalc() {
        var base = parseInt(form.getAttribute('data-price-base-cents'), 10) || 0;
        var total = base;
        form.querySelectorAll('[data-addon-toggle]:checked').forEach(function (t) {
          total += parseInt(t.getAttribute('data-addon-price-cents'), 10) || 0;
        });
        var el = form.querySelector('[data-buy-btn-price]');
        if (el) el.textContent = moneyFmt(total);
      }

      // purchase options: one-time vs a real Subscribe & Save selling plan
      var poBox = form.querySelector('[data-purchase-options]');
      var planInput = form.querySelector('[data-selling-plan-input]');
      var freqSelect = poBox ? poBox.querySelector('[data-po-freq]') : null;
      function applyPurchaseType() {
        var chosen = form.querySelector('[data-po-radio]:checked');
        var subscribing = chosen && chosen.value === 'subscribe';
        if (freqSelect) freqSelect.disabled = !subscribing;
        var onetime = parseInt(form.getAttribute('data-onetime-price-cents'), 10) || 0;
        if (subscribing && freqSelect && freqSelect.selectedOptions[0]) {
          if (planInput) planInput.value = freqSelect.value;
          form.setAttribute('data-price-base-cents', freqSelect.selectedOptions[0].getAttribute('data-price-cents') || onetime);
        } else {
          if (planInput) planInput.value = '';
          form.setAttribute('data-price-base-cents', onetime);
        }
        recalc();
      }
      if (poBox) {
        poBox.querySelectorAll('[data-po-radio]').forEach(function (r) { r.addEventListener('change', applyPurchaseType); });
        if (freqSelect) freqSelect.addEventListener('change', applyPurchaseType);
      }

      form.addEventListener('change', function (evt) {
        if (evt.target.matches('[data-addon-toggle]')) recalc();
      });
    });
  } catch (e) {}

  // simple AJAX add-to-cart for product forms carrying data-ajax-cart — supports any number
  // of bundled add-ons (bathroom lid, nappy bag roll) whose [data-addon-toggle] is checked
  document.addEventListener('submit', function (evt) {
    var form = evt.target.closest('form[data-ajax-cart]');
    if (!form) return;
    evt.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    var mainItem = { id: form.querySelector('[name="id"]').value, quantity: 1 };
    var planInput = form.querySelector('[data-selling-plan-input]');
    if (planInput && planInput.value) mainItem.selling_plan = planInput.value;
    var items = [mainItem];
    form.querySelectorAll('[data-addon-toggle]:checked').forEach(function (t) {
      items.push({ id: t.getAttribute('data-addon-variant-id'), quantity: 1 });
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = 'Added ✓'; }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1800);
      })
      .catch(function () {
        if (btn) { btn.textContent = 'Try again'; btn.disabled = false; }
      });
  });

  // mega menu (click toggle + hover-intent on desktop, click-only on touch)
  try {
    var megaTrigger = document.getElementById('megaTrigger');
    var megaPanel = document.getElementById('megaPanel');
    if (megaTrigger && megaPanel) {
      var closeTimer = null;
      function openMega() {
        clearTimeout(closeTimer);
        megaPanel.classList.add('open');
        megaTrigger.setAttribute('aria-expanded', 'true');
      }
      function closeMega() {
        megaPanel.classList.remove('open');
        megaTrigger.setAttribute('aria-expanded', 'false');
      }
      megaTrigger.addEventListener('click', function () {
        if (megaPanel.classList.contains('open')) closeMega(); else openMega();
      });
      megaTrigger.addEventListener('mouseenter', openMega);
      megaTrigger.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(closeMega, 200);
      });
      megaPanel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      megaPanel.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(closeMega, 200);
      });
      document.addEventListener('click', function (evt) {
        if (!megaTrigger.contains(evt.target) && !megaPanel.contains(evt.target)) closeMega();
      });
      document.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape') closeMega();
      });
    }
  } catch (e) {}

  // video showcase — click-to-play YouTube facade (real thumbnail, no iframe weight until a visitor opts in)
  try {
    document.querySelectorAll('.video-thumb[data-yt]').forEach(function (thumb) {
      function play() {
        var id = thumb.getAttribute('data-yt');
        var title = thumb.getAttribute('data-yt-title') || 'Video';
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        iframe.title = title;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        thumb.innerHTML = '';
        thumb.appendChild(iframe);
      }
      thumb.addEventListener('click', play);
      thumb.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter' || evt.key === ' ') { evt.preventDefault(); play(); }
      });
    });
  } catch (e) {}

  // video showcase — click-to-play facade for a real, natively-hosted Shopify video
  try {
    document.querySelectorAll('.video-thumb[data-native-video]').forEach(function (thumb) {
      function play() {
        var src = thumb.getAttribute('data-native-video');
        var video = document.createElement('video');
        video.src = src;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        thumb.innerHTML = '';
        thumb.appendChild(video);
      }
      thumb.addEventListener('click', play);
      thumb.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter' || evt.key === ' ') { evt.preventDefault(); play(); }
      });
    });
  } catch (e) {}

  // mobile nav toggle
  try {
    var toggle = document.getElementById('nav-mobile-toggle');
    var links = document.getElementById('nav-links');
    if (toggle && links) {
      toggle.addEventListener('click', function () {
        var open = links.classList.toggle('open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    }
  } catch (e) {}
})();

// Ask Magic — floating chat dock
(function () {
  var ASK = (window.MGT || {}).ask || {};
  if (!ASK.endpoint) return;
  var SESSION = (function () {
    try {
      var s = sessionStorage.getItem('magicAsk');
      if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem('magicAsk', s); }
      return s;
    } catch (e) { return 'anon' + Date.now(); }
  })();
  var PROMPTS = (ASK.prompts || []).map(function (s) { return String(s).trim(); }).filter(Boolean);

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function mdLinks(t) {
    return esc(t)
      .replace(/\[([^\]]+)\]\((\/[^)\s]*|https:\/\/(?:www\.)?magicbabyproducts\.com(?:\.au)?[^)\s]*)\)/g, '<a href="$2">$1</a>')
      .replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
  }

  function Chat(host) {
    var hist = [], busy = false, lastHuman = 0, poll;
    host.innerHTML = '<div class="chat"><div class="chat-log" aria-live="polite"><div class="msg b">' + esc(ASK.welcome || 'Hi. How can I help?') + '</div></div><form><input placeholder="Type your question" aria-label="Your question" maxlength="500"><button type="submit">Ask</button></form></div>';
    var log = host.querySelector('.chat-log'), inp = host.querySelector('input');
    function add(c, html) {
      var m = document.createElement('div');
      m.className = 'msg ' + c;
      m.innerHTML = html;
      log.appendChild(m);
      log.scrollTop = log.scrollHeight;
      return m;
    }
    function startPoll() {
      if (poll || !ASK.endpoint) return;
      poll = setInterval(function () {
        if (document.hidden) return;
        fetch(ASK.endpoint + '?session=' + encodeURIComponent(SESSION) + '&after=' + lastHuman)
          .then(function (r) { return r.json(); })
          .then(function (j) {
            (j.replies || []).forEach(function (r) { lastHuman = Math.max(lastHuman, r.id || 0); add('h', mdLinks(r.answer || '')); });
          })
          .catch(function () {});
      }, 15000);
    }
    function ask(q) {
      if (busy || !q) return;
      busy = true;
      add('u', esc(q));
      inp.value = '';
      var el = add('b', 'Thinking…');
      hist.push({ role: 'user', content: q });
      fetch(ASK.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: hist.slice(-12), session: SESSION, page: location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok && j.ok, j: j }; }); })
        .then(function (x) {
          if (!x.ok) throw new Error(x.j.error || 'Ask Magic is busy. Try again shortly, or call 1300 722 302.');
          el.innerHTML = mdLinks(x.j.reply);
          hist.push({ role: 'assistant', content: x.j.reply });
          startPoll();
        })
        .catch(function (e) { hist.pop(); el.textContent = e.message || 'Ask Magic is busy. Try again shortly, or call 1300 722 302.'; })
        .then(function () { busy = false; log.scrollTop = log.scrollHeight; });
    }
    host.querySelector('form').addEventListener('submit', function (e) { e.preventDefault(); ask(inp.value.trim()); });
    host._ask = ask;
  }

  document.querySelectorAll('[data-chat]').forEach(Chat);

  function openAsk() {
    var p = document.querySelector('[data-ask-panel]'), f = document.querySelector('[data-ask-open]');
    if (!p) return;
    p.hidden = false;
    if (f) f.setAttribute('aria-expanded', 'true');
    var i = p.querySelector('input');
    if (i) setTimeout(function () { i.focus(); }, 50);
  }
  function closeAsk() {
    var p = document.querySelector('[data-ask-panel]'), f = document.querySelector('[data-ask-open]');
    if (!p) return;
    p.hidden = true;
    if (f) f.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (evt) {
    var b = evt.target.closest('[data-ask-q]');
    if (!b) return;
    var c = document.querySelector('[data-chat="widget"]');
    if (c && c._ask) { openAsk(); c._ask(b.getAttribute('data-ask-q')); }
  });

  try {
    var dock = document.querySelector('[data-askdock]');
    if (dock) {
      var chips = document.querySelector('[data-ask-chips]', dock);
      if (chips) {
        chips.innerHTML = PROMPTS.slice(0, 3).map(function (q) { return '<button type="button" data-ask-q="' + esc(q) + '">' + esc(q) + '</button>'; }).join('');
      }
      function chipState() { dock.classList.toggle('min', window.scrollY > 240); }
      window.addEventListener('scroll', chipState, { passive: true });
      chipState();
      var openBtn = document.querySelector('[data-ask-open]', dock);
      if (openBtn) openBtn.addEventListener('click', function () {
        var p = document.querySelector('[data-ask-panel]');
        if (p && p.hidden) openAsk(); else closeAsk();
      });
      var closeBtn = document.querySelector('[data-ask-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeAsk);
    }
  } catch (e) {}
})();

// Cart drawer — real cart.js data, free-shipping progress, and a lid/bag-roll upsell
(function () {
  var CFG = (window.MGT || {}).cart || {};
  var FREE_SHIP_CENTS = CFG.freeShippingCents || 10000;
  var LID_PREFIXES = { heka: 'heka-toilet-lid', thoth: 'thoth-toilet-lid' };
  var BAGROLL_HANDLE = CFG.bagrollHandle || 'magic-bin-bag-roll';

  var veil = document.querySelector('[data-cart-veil]');
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!veil || !drawer) return;

  var linesEl = drawer.querySelector('[data-cart-lines]');
  var emptyEl = drawer.querySelector('[data-cart-empty]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var shipFill = drawer.querySelector('[data-cart-ship-fill]');
  var shipMsg = drawer.querySelector('[data-cart-ship-msg]');
  var upsellBox = drawer.querySelector('[data-cart-upsell]');
  var lidRow = drawer.querySelector('[data-cart-upsell-lid]');
  var bagRow = drawer.querySelector('[data-cart-upsell-bag]');

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function handleize(s) { return String(s).toLowerCase().replace(/[^a-z0-9\s-]/g, '').trim().replace(/[\s-]+/g, '-'); }
  function thumb(url, size) { return url ? url.replace(/(\.[a-z]+)(\?.*)?$/i, '_' + size + 'x$1$2') : ''; }

  function open() {
    veil.hidden = false; drawer.hidden = false;
    void drawer.offsetWidth;
    veil.classList.add('open'); drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    veil.classList.remove('open'); drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    setTimeout(function () { veil.hidden = true; drawer.hidden = true; }, 320);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count <= 0;
    });
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function () { return fetchCart(); }).then(renderCart);
  }

  function familyFromHandle(handle) {
    if (!handle) return null;
    if (handle.indexOf('heka') > -1) return 'heka';
    if (handle.indexOf('thoth') > -1) return 'thoth';
    return null;
  }

  var upsellToken = 0;
  function updateUpsells(cart) {
    var token = ++upsellToken;
    var hasBagRoll = cart.items.some(function (i) { return i.handle === BAGROLL_HANDLE; });
    var lidCandidate = null;
    cart.items.some(function (item) {
      var family = familyFromHandle(item.handle);
      if (!family || !LID_PREFIXES[family]) return false;
      var titleParts = String(item.product_title || '').split(' - ');
      if (titleParts.length < 2) return false;
      var colour = titleParts[titleParts.length - 1];
      var lidHandle = LID_PREFIXES[family] + '-' + handleize(colour);
      var alreadyHasLid = cart.items.some(function (i) { return i.handle === lidHandle; });
      if (alreadyHasLid) return false;
      lidCandidate = { handle: lidHandle, colour: colour };
      return true;
    });

    function checkUpsellVisibility() {
      if (lidRow.hidden && bagRow.hidden) upsellBox.hidden = true;
    }

    if (lidCandidate) {
      fetch('/products/' + lidCandidate.handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error('no lid'); return r.json(); })
        .then(function (lid) {
          if (token !== upsellToken) return;
          if (!lid.available) throw new Error('unavailable');
          lidRow.hidden = false;
          lidRow.querySelector('[data-cart-upsell-lid-img]').src = thumb(lid.featured_image, 80);
          lidRow.querySelector('[data-cart-upsell-lid-title]').textContent = lid.title;
          lidRow.querySelector('[data-cart-upsell-lid-price]').textContent = money(lid.price);
          var btn = lidRow.querySelector('[data-cart-upsell-lid-add]');
          btn.disabled = false;
          btn.onclick = function () { btn.disabled = true; addItems([{ id: pickVariant(lid).id, quantity: 1 }]).then(function () { btn.disabled = false; }); };
          upsellBox.hidden = false;
        })
        .catch(function () { if (token === upsellToken) { lidRow.hidden = true; checkUpsellVisibility(); } });
    } else {
      lidRow.hidden = true;
    }

    if (!hasBagRoll) {
      fetch('/products/' + BAGROLL_HANDLE + '.js')
        .then(function (r) { if (!r.ok) throw new Error('no bagroll'); return r.json(); })
        .then(function (bag) {
          if (token !== upsellToken) return;
          if (!bag.available) throw new Error('unavailable');
          bagRow.hidden = false;
          bagRow.querySelector('[data-cart-upsell-bag-img]').src = thumb(bag.featured_image, 80);
          bagRow.querySelector('[data-cart-upsell-bag-price]').textContent = money(bag.price);
          var btn = bagRow.querySelector('[data-cart-upsell-bag-add]');
          btn.disabled = false;
          btn.onclick = function () { btn.disabled = true; addItems([{ id: pickVariant(bag).id, quantity: 1 }]).then(function () { btn.disabled = false; }); };
          upsellBox.hidden = false;
        })
        .catch(function () { if (token === upsellToken) { bagRow.hidden = true; checkUpsellVisibility(); } });
    } else {
      bagRow.hidden = true;
    }

    checkUpsellVisibility();
  }

  function pickVariant(product) {
    var avail = product.variants.filter(function (v) { return v.available; });
    return avail[0] || product.variants[0];
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);
    linesEl.innerHTML = '';
    if (!cart.items.length) {
      linesEl.appendChild(emptyEl);
      upsellBox.hidden = true;
    } else {
      cart.items.forEach(function (item) {
        var div = document.createElement('div');
        div.className = 'cd-line';
        var variantBit = (item.variant_title && item.variant_title !== 'Default Title') ? ' — ' + esc(item.variant_title) : '';
        div.innerHTML =
          '<img src="' + thumb(item.image, 140) + '" alt="' + esc(item.product_title) + '">' +
          '<div class="cd-line-info">' +
            '<b>' + esc(item.product_title) + variantBit + '</b>' +
            '<span class="cd-line-price">' + money(item.final_price) + '</span>' +
            '<div class="cd-qty"><button type="button" data-dec aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button type="button" data-inc aria-label="Increase quantity">+</button></div>' +
            '<button type="button" class="cd-line-remove" data-remove>Remove</button>' +
          '</div>';
        div.querySelector('[data-dec]').addEventListener('click', function () { changeLine(item.key, item.quantity - 1); });
        div.querySelector('[data-inc]').addEventListener('click', function () { changeLine(item.key, item.quantity + 1); });
        div.querySelector('[data-remove]').addEventListener('click', function () { changeLine(item.key, 0); });
        linesEl.appendChild(div);
      });
      updateUpsells(cart);
    }

    subtotalEl.textContent = money(cart.total_price);

    var remaining = FREE_SHIP_CENTS - cart.total_price;
    var pct = Math.max(0, Math.min(100, (cart.total_price / FREE_SHIP_CENTS) * 100));
    shipFill.style.width = pct + '%';
    if (cart.total_price <= 0) {
      shipMsg.innerHTML = '&nbsp;';
    } else if (remaining <= 0) {
      shipMsg.innerHTML = 'You’ve unlocked <b>free shipping</b>.';
    } else {
      shipMsg.innerHTML = 'Add <b>' + money(remaining) + '</b> more for free shipping.';
    }
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (evt) {
      evt.preventDefault();
      fetchCart().then(renderCart);
      open();
    });
  });
  var closeBtn2 = drawer.querySelector('[data-cart-close]');
  if (closeBtn2) closeBtn2.addEventListener('click', close);
  veil.addEventListener('click', close);
  document.addEventListener('keydown', function (evt) { if (evt.key === 'Escape' && !drawer.hidden) close(); });

  document.addEventListener('cart:updated', function () {
    fetchCart().then(function (cart) { renderCart(cart); open(); });
  });

  // initial count on page load
  fetchCart().then(function (cart) { updateCartCount(cart.item_count); });
})();
